import { Button, Dialog, DialogContent, DialogTitle, FormControl, Grid, InputLabel, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import { DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import clsx from 'clsx';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { format } from "date-fns";
import { useFormik } from "formik";
import { getErrorMessage, isError } from "libs/utils/form";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addHolidays, getHolidays } from "redux/modules/holidaySlice";
import DatetimeService from "services/DatetimeService";
import * as yup from "yup";


const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function createData(a, b, c) {
  return { a, b, c };
}


const useStyles = makeStyles((theme) => ({
  warpListVisa: {
    marginTop: 50
  },
  warpButton: {
    marginTop: 30,
    display: 'flex',
    justifyContent: 'space-between',
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpForm: {
    marginTop: 30
  },
  warpTabs: {
    marginTop: 30
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: '#F1F3F9',
    color: '#8898AA'
  },
  buttonViewDetail: {
    // width: 150,
    backgroundColor: '#00D0FF',
    marginRight: 10
  },
  warpButtonDetail: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonStatusDetail: {

    backgroundColor: 'white',
    padding: 5,
    borderRadius: '50%',
    boxShadow: '0px 0px 2px 2px rgba(23, 43, 77, 0.2)'
  },
  warpData: {
    marginTop: 20
  },
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  indicator: {
    backgroundColor: '#1094D8',
    color: 'white'
  },
  iconStatus: {
    color: '#2DCE98',
    marginRight: 5
  },
  warpButtonSave: {
    textAlign: 'right',
    marginTop: 30
  },
  buttonSave: {
    marginLeft: 5,
    width: 120
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex", justifyContent: "space-between", alignItems: "center"
  },
  wrapDateControl: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    marginBottom: 15
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  dateControl: {
    marginRight: 5,
    width: '100%'
  },
  btnEdit: {
    color: 'white',
    backgroundColor: '#2DCE98',
    marginLeft: 10
  },
  btnRemove: {
    color: 'white',
    backgroundColor: '#F53C56',
    marginLeft: 10
  },
  warpRowDialog: {
    marginTop: 10
  },
  dtitle: {
    color: '#40B8D4',
  },
  d2title: {
    color: '#172B4D',
    paddingBottom: 10

  },
  textDialog: {
    width: '100%',
  },
  warpDialog: {
    padding: "30px", minWidth: "600px", minHeight: "200px"
  },
}));



function HolidaysPage() {
  const { t, i18n } = useTranslation();


  const classes = useStyles();
  const dispatch = useDispatch();
  const { list: holidays } = useSelector((state) => state.holiday);
  const [open, setOpen] = React.useState(false);

  const [date, setDate] = React.useState(new Date());
  const [dialogData, setDialogData] = React.useState(false);


  useEffect(async () => {
    await getHolidayList(new Date());
  }, []);


  const handleAddHoliday = async () => {
    setDialogData({
      holidayID: null,
      date: new Date(),
      remark: ''
    })
    setOpen(true);
  }


  const getHolidayList = async (_date) => {
    const flDate = DatetimeService.getFirstAndLastDayOfYear(new Date(_date));
    const body = {
      startDate: format(flDate.firstDate, "yyyy-MM-dd"),
      endDate: format(flDate.lastDate, "yyyy-MM-dd")
    }
    await dispatch(getHolidays(body));
  }


  const handleClose = async (holiday) => {

    if (holiday) {
      console.log(holiday);

      const body = {
        holidayID: holiday.holidayID,
        holidayDate: format(new Date(holiday.holidayDate), "yyyy-MM-dd"),
        remark: holiday.remark,
        status: false
      }
      await dispatch(addHolidays(holiday));
      await getHolidayList(date);
    }
    setOpen(false);
  };


  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="Thailand Public Holidays" />
      {
        open &&
        <HolidayDialog data={dialogData} open={open} onClose={handleClose} />
      }

      <div className={classes.warpSubHeader} >
        <AdminTitle2 subTitle="Holidays" />
        <div className={classes.wrapDateControl}>
          <FormControl variant="outlined" className={clsx(classes.dateControl)} >
            <DatePicker
              views={['year']}
              label="Year"
              value={date}
              onChange={async (_date) => {
                setDate(_date.format("YYYY-MM-DD"))
                await getHolidayList(_date);
              }}
              renderInput={(params) => <TextField {...params} helperText={null} />}
            />
          </FormControl>
          <Button variant="contained" size="medium" color="primary" onClick={() =>
            handleAddHoliday()} className={classes.buttonDialogSave}>
            <AddIcon />
            เพิ่มวันหยุด
          </Button>
        </div>

      </div >

      <div className={classes.warpData}>
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <TableHead >
              <TableRow>
                <StyledTableCell className={classes.tableHead} style={{ 'width': 200, textAlign: 'center' }}>Date</StyledTableCell>
                <StyledTableCell className={classes.tableHead}>Holiday Name</StyledTableCell>
                <StyledTableCell className={classes.tableHead} style={{ 'width': 200, textAlign: 'center' }}>Manage</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {holidays.map((row, index) => (
                <StyledTableRow key={row.holidayID}>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                    {row.holidayDate ? format(new Date(row.holidayDate), "yyyy-MM-dd") : null}
                  </StyledTableCell>
                  <StyledTableCell >{row.remark}</StyledTableCell>
                  <StyledTableCell >
                    <div className={classes.warpButtonDetail}>
                      <Button size="small" color="primary" className={classes.btnEdit} onClick={async () => {
                        setDialogData({
                          holidayID: row.holidayID,
                          date: new Date(row.holidayDate),
                          remark: row.remark
                        })
                        setOpen(true);
                      }}>
                        แก้ไข
                      </Button>
                      <Button size="small" color="error" className={classes.btnRemove} onClick={async () => {

                        if (!window.confirm('Do you want to delete this holiday?')) { return; }
                        const body = {
                          holidayID: row.holidayID,
                          holidayDate: format(new Date(row.holidayDate), "yyyy-MM-dd"),
                          remark: row.remark,
                          status: false
                        }
                        await dispatch(addHolidays(body));
                        await getHolidayList(date);

                      }}>
                        ลบ
                      </Button>
                    </div>
                  </StyledTableCell>

                </StyledTableRow>
              ))}

            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Paper>
  );
}

export default HolidaysPage;



function HolidayDialog(props) {
  const useStylesHoliday = makeStyles((theme) => ({

    warpRowDialog: {
      marginTop: 10
    },
    dtitle: {
      color: '#40B8D4',
    },
    d2title: {
      color: '#172B4D',
      paddingBottom: 10

    },
    textDialog: {
      width: '100%',
    },
    warpDialog: {
      padding: "30px", minWidth: "600px", minHeight: "200px"
    },
    formControl: {
      width: '100%'
    },
    warpFormControl: {
      paddingLeft: 10,
      paddingRight: 10,
      marginTop: 10
    },
    warpButtonDialogSave: {
      display: 'flex'
    },
    buttonDialogSave: {
      width: '100%',
      margin: '15px 5px'
    },
  }));


  const classes = useStylesHoliday();
  const { onClose, open, data } = props;


  const _date = (data?.date) ? new Date(data?.date) : new Date();

  const validationSchema = yup.object({
    date: yup.date().required("Date is required."),
    remark: yup.string().required("Holiday name is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      holidayID: data?.holidayID,
      date: _date,
      remark: data?.remark,
    },
    onSubmit: async (values) => {

      const body = {
        holidayID: values.holidayID,
        holidayDate: format(new Date(values.date), "yyyy-MM-dd"),
        remark: values.remark,
        status: true
      };

      onClose(body);
    },
  });


  const handleClose = () => {
    onClose(null);
  };





  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>กำหนดวันหยุด</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.warpRowDialog}>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <InputLabel className={classes.d2title}>วันที่</InputLabel>
                <FormControl variant="outlined" className={classes.formControl}>

                  <DatePicker
                    className={classes.formControl}
                    inputVariant="outlined"
                    openTo="year"
                    format="DD-MM-YYYY"
                    views={["year", "month", "date"]}
                    name={`date`}
                    value={formik.values?.date || null}
                    onChange={(date) => {
                      formik.setFieldValue(
                        "date",
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError("date", formik)}
                    helperText={getErrorMessage("date", formik)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <InputLabel className={classes.d2title}>วันหยุด</InputLabel>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField variant="outlined"
                    name={`remark`}
                    value={formik.values.remark}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(`remark`, formik)}
                    helperText={getErrorMessage(
                      `remark`,
                      formik
                    )}
                    className={classes.textDialog}

                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" type="button" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
                <Button variant="contained" size="medium" type="submit" color="primary" className={classes.buttonDialogSave}>
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog >
  );
}

